import React, { useCallback, useContext, useEffect, useState } from 'react';
import close from '../Components/Images/x-close.png';
import copy from '../Components/Images/copy.png';
import { Context } from '../Context/Context';
import { GoArrowUpRight } from 'react-icons/go';
import Select from 'react-select';

const AcctDetailsBar = ({
    UserAcctDetails,
    setSelectedCurrency,
    selectedCurrency,
    balance,
    roundUp,
    currencyLogos,
    output,
    selectedAccount,
}) => {
    const { acctDetailsBar, handleAcctDetailsBar, handleSendBar } = useContext(Context);
    const [copied, setCopied] = useState(false);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');

    const handleCopy = async () => {
        const address = selectedAccount?.address
            ? [
                selectedAccount.address.streetLine1,
                selectedAccount.address.streetLine2,
                selectedAccount.address.city,
                selectedAccount.address.stateOrProvince,
                selectedAccount.address.postalCode,
                selectedAccount.address.countryCode,
            ]
                .filter(Boolean)
                .join(', ')
            : 'N/A';

        const details = `
Bank Information:
${selectedAccount?.bank_name || 'N/A'}
${address}

Account Name:
${selectedAccount?.first_name || 'N/A'} ${selectedAccount?.last_name || 'N/A'}

${selectedAccount?.account_number ? `Account Number:\n${selectedAccount.account_number}\n` : ''}
${selectedAccount?.routing_number ? `Routing Number:\n${selectedAccount.routing_number}\n` : ''}
${selectedAccount?.iban ? `IBAN Number:\n${selectedAccount.iban}\n` : ''}
${selectedAccount?.bic_swift ? `BIC Swift Number:\n${selectedAccount.bic_swift}\n` : ''}
  `.trim();

        try {
            await navigator.clipboard.writeText(details);
            setCopied(true);
            setTimeout(() => setCopied(false), 1000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    //  const handleCopy = async () => {
    //     const textToCopy = selectedAccount.account_number?.trim() || selectedAccount.iban?.trim();

    //     try {
    //         await navigator.clipboard.writeText(textToCopy);
    //         setCopied(true);

    //         setTimeout(() => setCopied(false), 1000);
    //     } catch (err) {
    //         console.error('Failed to copy:', err);
    //     }
    // };

    const exchangeRates = {
        USD: 1,       // base
        EUR: 0.85,    // example rate
    };

    const convertBalance = (amount, fromCurrency, toCurrency) => {
        if (!amount || !fromCurrency || !toCurrency) return 0;
        const inUSD = amount / exchangeRates[fromCurrency]; // convert to USD first
        return inUSD * exchangeRates[toCurrency];           // convert to target
    };

    const currencyOptions = UserAcctDetails.map((acct) => ({
        value: acct.currency,
        label: (
            <div className="flex items-center gap-2">
                <img src={currencyLogos[acct.currency]} alt={acct.currency} className="w-5 h-4" />
                <span>{acct.currency}</span>
            </div>
        )
    }));

    const selectedOption = currencyOptions.find(opt => opt.value === selectedCurrency);

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 4px', // adjust this value to reduce the space
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            cursor: 'pointer',
        }),
    }


    const fetchAcctStatus = useCallback(async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/account/${selectedAccount.id}/status`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );
            const data = await res.json();
            setStatus(data);
        } catch (error) {
            console.error('Error fetching statuses:', error);
        } finally {
            setLoading(false);
        }
    }, [selectedAccount.id]);

    useEffect(() => {
        if (acctDetailsBar && selectedAccount?.id) {
            fetchAcctStatus();
        }
    }, [acctDetailsBar, fetchAcctStatus, selectedAccount?.id]);

    return (
        <div
            className={`fixed top-0 h-screen bg-white lg:p-10 py-8 px-4 duration-700 z-30 text-[#1D1C1F] ${acctDetailsBar ? 'sm:w-[510px] w-full right-0' : 'right-[-100%] w-[40%]'
                }`}
        >
            {loading ? (
                <div className="flex items-center justify-center h-full">
                    <p className="text-lg font-medium text-[#531CB3]">Loading account details...</p>
                </div>
            ) : (
                <>
                    <div className="flex justify-between">
                        <div>
                            <div className="mt-2 flex gap-2 items-center">
                                Account Status:
                                <p
                                    className={
                                        status?.status === 'APPROVED'
                                            ? 'bg-green-200 text-green-500 p-1 px-2 rounded-full text-[14px]'
                                            : 'bg-red-200 text-red-500 p-1 px-2 rounded-full text-[14px]'
                                    }
                                >
                                    {status?.status === 'APPROVED' ? 'APPROVED' : 'NOT APPROVED'}
                                </p>
                            </div>
                            <div className="mt-1 flex items-center gap-2">
                                <Select
                                    styles={customStyles}
                                    value={selectedOption}
                                    onChange={(selected) => setSelectedCurrency(selected.value)}
                                    options={currencyOptions}
                                    className="react-select-container w-[120px]"
                                    classNamePrefix="react-select"
                                />

                                {output && <p className="mt-1 text-[14px]">{output} Balance</p>}
                            </div>
                            <div className="mt-[13px]">
                                <p className="text-[36px] font-semibold">
                                    {selectedCurrency && selectedAccount && (
                                        <>
                                            {selectedCurrency === "USD" ? "$" : "€"}
                                            {roundUp(
                                                convertBalance(balance.balance, balance.currency || "USD", selectedCurrency),
                                                1
                                            )}
                                        </>
                                    )}
                                </p>
                                <div className="flex gap-4 text-white mt-[12px]">
                                    <button
                                        onClick={() => {
                                            handleSendBar();
                                            handleAcctDetailsBar();
                                        }}
                                        className={`flex items-center w-ful gap-2 p-2 px-4 justify-center rounded-lg ${balance?.balance > 0.0 ? 'bg-[#531CB3]' : 'bg-[#E8E1F5] cursor-not-allowed'
                                            }`}
                                    >
                                        <GoArrowUpRight />
                                        Send
                                    </button>
                                    {/* <button
                                        className={`flex items-center w-full gap-2 p-2 rounded-lg ${balance?.balance > 0.0 ? 'bg-[#531CB3]' : 'bg-[#E8E1F5] cursor-not-allowed'
                                            }`}
                                    >
                                        <LuArrowLeftRight />
                                        Receive
                                    </button> */}
                                </div>
                            </div>
                        </div>
                        <img className="size-5 mt-1 cursor-pointer" src={close} alt="" onClick={handleAcctDetailsBar} />
                    </div>

                    {/* Bank details */}
                    <div className="mt-[25px]">
                        <div className="flex justify-between items-center">
                            <p className="text-[18px] font-medium">Bank Account Details</p>
                            <button
                                onClick={handleCopy}
                                className="flex items-center gap-2 text-[#542d9d] text-[14px] font-semibold cursor-pointer bg-transparent border-none focus:outline-none"
                            >
                                {copied ? 'Copied!' : 'Copy details'}
                                <img className="size-4" src={copy} alt="" />
                            </button>
                        </div>
                        <p className="pr-[120px] text-[#525154] text-[14px]">
                            Use this account to receive payments from your clients or friends.
                        </p>
                    </div>

                    <div className="mt-[20px]">
                        <p className="text-[#B5B3BA]">Bank Information</p>
                        <p className="text-[16px] font-medium">{selectedAccount?.bank_name || 'N/A'}</p>
                        <p className="text-[14px] text-[#525154]">
                            {selectedAccount?.address
                                ? [
                                    selectedAccount.address.streetLine1,
                                    selectedAccount.address.streetLine2,
                                    selectedAccount.address.city,
                                    selectedAccount.address.stateOrProvince,
                                    selectedAccount.address.postalCode,
                                    selectedAccount.address.countryCode,
                                ]
                                    .filter(Boolean)
                                    .join(', ')
                                : 'N/A'}
                        </p>
                    </div>

                    <div className="mt-[10px]">
                        <p className="text-[#B5B3BA]">Account Name</p>
                        <p className="text-[16px] font-medium">
                            {selectedAccount?.first_name || 'N/A'} {selectedAccount?.last_name || 'N/A'}
                        </p>
                    </div>
                    {selectedAccount?.account_number && (
                        <div className="mt-[10px]">
                            <p className="text-[#B5B3BA]">Account Number</p>
                            <p className="text-[16px] font-medium">{selectedAccount.account_number}</p>
                        </div>
                    )}
                    {selectedAccount?.routing_number && (
                        <div className="mt-[10px]">
                            <p className="text-[#B5B3BA]">Routing Number</p>
                            <p className="text-[16px] font-medium">{selectedAccount.routing_number}</p>
                        </div>
                    )}
                    {selectedAccount?.iban && (
                        <div className="mt-[10px]">
                            <p className="text-[#B5B3BA]">IBAN Number</p>
                            <p className="text-[16px] font-medium">{selectedAccount.iban}</p>
                        </div>
                    )}
                    {selectedAccount?.bic_swift && (
                        <div className="mt-[10px]">
                            <p className="text-[#B5B3BA]">BIC Swift Number</p>
                            <p className="text-[16px] font-medium">{selectedAccount.bic_swift}</p>
                        </div>
                    )}
                </>
            )
            }
        </div >
    );
};

export default AcctDetailsBar;
